// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
    if (wixWindow.formFactor === "Mobile") {
        $w("#waze").show();
        $w("#wazetext").show();
        $w("#booknow").show();
    }
});